import UnknownRoute from "discourse/routes/unknown";
export default class ExceptionUnknown extends UnknownRoute {
  templateName = "unknown";
}